import { Lock, FileText, ShieldCheck } from "lucide-react";

const OPTIONS = [
  { id: false, icon: FileText, t: "Standard", d: "Transcript, Aurora summary and email recap are kept after the call." },
  { id: true, icon: Lock, t: "Encrypted · No trace", d: "Messages encrypted at rest, voice never stored. Everything is permanently deleted when the call ends." },
];

export const PrivacyPicker = ({ value, onChange }) => (
  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-testid="create-room-privacy-picker">
    {OPTIONS.map((o) => {
      const on = value === o.id;
      return (
        <button type="button" key={o.t} onClick={() => onChange(o.id)} data-testid={`privacy-option-${o.id ? "encrypted" : "standard"}`}
          className={`border p-4 text-left transition-[border-color,box-shadow,background-color] duration-200 ${on
            ? o.id ? "border-[color:var(--au-green)] bg-cyan-400/10 shadow-[0_0_20px_rgba(61,219,232,0.2)]" : "border-foreground bg-muted/60"
            : "border-border hover:border-muted-foreground"}`}>
          <div className="flex items-center gap-2">
            <o.icon size={15} className={o.id ? "text-[color:var(--au-green)]" : "text-muted-foreground"} />
            <span className="font-display text-sm font-bold">{o.t}</span>
            {on && <span className="ml-auto font-mono text-[10px] tracking-widest text-[color:var(--au-green)]">SELECTED</span>}
          </div>
          <p className="mt-2 text-xs text-muted-foreground">{o.d}</p>
        </button>
      );
    })}
  </div>
);

export const NoTraceBanner = ({ compact = false, testId = "no-trace-banner" }) => (
  <div className={`flex items-start gap-3 border border-[color:var(--au-green)] bg-cyan-400/10 ${compact ? "px-4 py-2" : "p-4"}`} data-testid={testId}>
    <ShieldCheck size={compact ? 15 : 20} className="mt-0.5 shrink-0 text-[color:var(--au-green)]" />
    <div>
      <div className="font-mono text-[11px] font-semibold uppercase tracking-widest text-[color:var(--au-green)]">Encrypted · No-trace room</div>
      {!compact && <p className="mt-1 text-sm text-muted-foreground">Messages are encrypted at rest and voice is never stored. When the call ends, everything is permanently deleted — no transcript, no summary, no recap.</p>}
    </div>
  </div>
);

export const NoTraceTag = () => (
  <span className="inline-flex items-center gap-1 border border-[color:var(--au-green)] px-1.5 py-0.5 font-mono text-[10px] tracking-widest text-[color:var(--au-green)]" data-testid="no-trace-tag">
    <Lock size={10} /> NO TRACE
  </span>
);
